/**
 * Dynamically imports canvas-confetti only when called.
 * This keeps the library OUT of the initial JS bundle,
 * saving ~50KB on page load. It is only downloaded the
 * first time a user triggers a celebration (add-to-cart,
 * booking success, etc.).
 */

const DEFAULT_COLORS = ['#FF9933', '#FFC107', '#E0E0E0'];

export async function triggerConfetti(opts?: {
  colors?: string[];
  zIndex?: number;
  originY?: number;
}) {
  const confetti = (await import('canvas-confetti')).default;
  const colors = opts?.colors ?? DEFAULT_COLORS;
  const zIndex = opts?.zIndex ?? 200;
  const y = opts?.originY ?? 0.7;

  confetti({ particleCount: 150, angle: 60,  spread: 80, origin: { x: 0, y }, colors, zIndex });
  confetti({ particleCount: 150, angle: 120, spread: 80, origin: { x: 1, y }, colors, zIndex });
}
